import "slick-carousel";
import jQuery from "jquery";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import $ from "jquery";
window.jQuery = $;

if ($(".services_list").length > 0) {
  $(".services_list").slick({
    autoplaySpeed: 5000,
    dots: false,
    arrows: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: false,
    //centerMode: true,
    centerPadding: "0px",
    variableWidth: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
}
